var map = {
	"./STERiJECT_02_1.png": "6379",
	"./STERiJECT_02_2.png": "cf986",
	"./STERiJECT_02_3.png": "d102",
	"./STERiJECT_02_4.png": "5710",
	"./STERiJECT_02_5.png": "17c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "34f6";